<td class="pia-listsBlock-item">
  <div class="pia-listsBlock-item-actions">
    @if (structure.is_example) {
    <a
      [routerLink]="['/structures', structure.id, 'section', 1, 'item', 1]"
      class="btn pia-tooltip"
    >
      <fa-icon [icon]="faEye"></fa-icon>
      <span
        title="{{ 'homepage.cards.item.consult_pia' | translate }}"
        class="pia-tooltip-text"
        >{{ "homepage.cards.item.consult_pia" | translate }}</span
      >
    </a>
    } @else {
    <a
      [routerLink]="['/structures', structure.id, 'section', 1, 'item', 1]"
      class="btn pia-tooltip"
    >
      <fa-icon [icon]="faPencil"></fa-icon>
      <span
        title="{{ 'homepage.lists.item.tools.edit' | translate }}"
        class="pia-tooltip-text"
        >{{ "homepage.lists.item.tools.edit" | translate }}</span
      >
    </a>
    }
    <a
      href="javascript:;"
      (click)="export(structure.id)"
      class="btn pia-tooltip"
    >
      <fa-icon [icon]="faDownload"></fa-icon>
      <span
        title="{{ 'homepage.lists.item.tools.export' | translate }}"
        class="pia-tooltip-text"
        >{{ "homepage.lists.item.tools.export" | translate }}</span
      >
    </a>
    <a
      href="javascript:;"
      (click)="duplicate(structure.id)"
      class="btn pia-tooltip"
    >
      <fa-icon [icon]="faFile"></fa-icon>
      <span
        title="{{ 'homepage.lists.item.tools.duplicate' | translate }}"
        class="pia-tooltip-text"
        >{{ "homepage.lists.item.tools.duplicate" | translate }}</span
      >
    </a>
    @if (!structure.is_example) {
    <a
      href="javascript:;"
      (click)="remove(structure.id)"
      class="btn pia-tooltip"
    >
      <fa-icon [icon]="faTrash"></fa-icon>
      <span
        title="{{ 'homepage.lists.item.tools.remove' | translate }}"
        class="pia-tooltip-text"
        >{{ "homepage.lists.item.tools.remove" | translate }}</span
      >
    </a>
    }
  </div>
</td>
<td class="pia-listsBlock-item">
  @if (!structure.is_example) {
  <div contenteditable (focusout)="onFocusOut('name', $event)">
    {{ structure.name }}
  </div>
  } @else {
  <div>{{ structure.name }}</div>
  }
</td>
<td class="pia-listsBlock-item">
  @if ( structure.updated_at && structure.updated_at.toString() !== 'Invalid
  Date' ) {
  <time>{{
    structure.updated_at
      | date: "shortDate":"":languagesService.selectedLanguage
  }}</time>
  }
</td>
<td class="pia-listsBlock-item">
  @if (!structure.is_example) {
  <div contenteditable (focusout)="onFocusOut('sector_name', $event)">
    {{ structure.sector_name }}
  </div>
  } @else {
  <div>{{ structure.sector_name }}</div>
  }
</td>
<td class="pia-listsBlock-item">
  <time>{{
    structure.created_at
      | date: "shortDate":"":languagesService.selectedLanguage
  }}</time>
</td>
